import { render, staticRenderFns } from "./PersonnelList.vue?vue&type=template&id=884595e6"
import script from "./PersonnelList.vue?vue&type=script&lang=js"
export * from "./PersonnelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports